var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAnalytic = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33331 8.66667H5.33331V14H1.33331V8.66667ZM10.6666 5.33333H14.6666V14H10.6666V5.33333ZM5.99998 2H9.99998V14H5.99998V2ZM2.66665 10V12.6667H3.99998V10H2.66665ZM7.33331 3.33333V12.6667H8.66665V3.33333H7.33331ZM12 6.66667V12.6667H13.3333V6.66667H12Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAnalytic, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/analytic.a7943dd0.svg";
export { ForwardRef as ReactComponent };